
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.DeliveryAndSendMerchandiser = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          attributes: {
            class: 'control-group lookup',
            id: 'container-lookup-organization-delivery-merchandiser',
          },
        },
        {
          items: [
            {
              items: [
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: Monet.I18n.getResourcesByKey('event.deliveryMerchandiser.timeIntervalInMinutes'),
                    },
                  ],
                  attributes: {
                    'class': 'control-label toInline',
                    for: 'timeIntervalInMinutes',
                  },
                },
                {
                  items: [
                    {
                      tag: 'input',
                      attributes: {
                        "type": 'text',
                        "name": 'timeIntervalInMinutes',
                        "maxlength": '6',
                        "alt": '',
                        "value": '',
                        "size": '7',
                        "id": 'timeIntervalInMinutes',
                        "class": 'modelAttribute textField mandatory',
                        "autocomplete": 'off',
                      },
                    },
                  ],
                  attributes: {
                    'class': 'controls toInline',
                  },
                },
              ],
              attributes: {
                class: 'control-group',
              },
            },
            {
              items: [
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: Monet.I18n.getResourcesByKey('event.deliveryMerchandiser.minutesToleranceBeforeDelivery'),
                    },
                  ],
                  attributes: {
                    class: 'control-label toInline',
                    'for': 'minutesToleranceBeforeDelivery',
                  },
                },
                {
                  items: [
                    {
                      tag: 'input',
                      attributes: {
                        "type": 'text',
                        "name": 'minutesToleranceBeforeDelivery',
                        "maxlength": '6',
                        "alt": '',
                        "value": '',
                        "size": '7',
                        "id": 'minutesToleranceBeforeDelivery',
                        "class": 'modelAttribute textField',
                        "autocomplete": 'off',
                      },
                    },
                  ],
                  attributes: {
                    'class': 'controls toInline',
                  },
                },
              ],
              attributes: {
                class: 'control-group',
              },
            },
          ],
          attributes: {
            id: 'intervalTimeRange',
          },
        },
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.deliveryMerchandiser.onlyPlannedRoutes'),
                },
              ],
              attributes: {
                class: 'control-label toInline',
                for: 'onlyPlannedRoutes',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'checkbox',
                    'name': 'onlyPlannedRoutes',
                    id: 'onlyPlannedRoutes',
                    'class': 'modelAttribute checkbox',
                  },
                },
              ],
              attributes: {
                class: 'controls toInline',
              },
            },
          ],
          attributes: {
            class: 'control-group',
            id: 'onlyPlannedRoutesContainer',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    const deliveryMerchandiserOrganizationId = 'container-lookup-organization-delivery-merchandiser';
    const nameSpace = 'EventLookupOrganizationDeliveryMerchandiser';
    const tabElements = document.getElementById('Event');
    const lookup = new Monet.UI.Fields.PowerLookup();
    const deliveryMerchandiserOrganizationElement = tabElements.querySelector(`#${deliveryMerchandiserOrganizationId}`);

    if (deliveryMerchandiserOrganizationElement) {
      deliveryMerchandiserOrganizationElement.innerHTML = '';

      lookup.setId(deliveryMerchandiserOrganizationId);
      lookup.setNameSpace(nameSpace);
      lookup.setBaseSelector(`#${deliveryMerchandiserOrganizationId}`);
      lookup.setMandatory(true);
      lookup.setDisplayKey('description');
      lookup.setLookUpEntity('Organization');
      lookup.render();
      lookup.setInputName('organization');
      lookup.setTextLabel(
        Monet.I18n.getResourcesByKey('event.organization')
      );

      App.Forms[nameSpace] = App.Forms[nameSpace] || {};
      App.Forms[nameSpace].lookupElement = lookup;

      deliveryMerchandiserOrganizationElement.appendChild(lookup.rootEl);
    }

    if (jsonParam) {
      const data = JSON.parse(jsonParam);

      if (data.organization) {
        lookup.setValue(data.organization);
      }

      if (data.timeIntervalInMinutes) {
        tabElements.querySelector('#timeIntervalInMinutes').value = data.timeIntervalInMinutes;
      }

      if (data.minutesToleranceBeforeDelivery) {
        tabElements.querySelector('#minutesToleranceBeforeDelivery').value = data.minutesToleranceBeforeDelivery;
      }

      if (data.onlyPlannedRoutes) {
        tabElements.querySelector('#onlyPlannedRoutes').checked = data.onlyPlannedRoutes;
      }
    }
  },
  retrieveParameter() {
    const tabElements = document.getElementById('Event');
    const lookup = App.Forms.EventLookupOrganizationDeliveryMerchandiser.lookupElement;
    const result = {};
    const timeIntervalInMinutesElement = tabElements.querySelector('#timeIntervalInMinutes');
    const minutesToleranceBeforeDeliveryElement = tabElements.querySelector('#minutesToleranceBeforeDelivery');
    const onlyPlannedRoutesPlanned = tabElements.querySelector('#onlyPlannedRoutes');

    if (lookup.input.value) {
      result.organization = lookup.getFullValue();
    }

    if (timeIntervalInMinutesElement.value) {
      result.timeIntervalInMinutes = parseInt(timeIntervalInMinutesElement.value, 10);
    }

    if (minutesToleranceBeforeDeliveryElement.value) {
      result.minutesToleranceBeforeDelivery = parseInt(minutesToleranceBeforeDeliveryElement.value, 10);
    }

    result.onlyPlannedRoutes = onlyPlannedRoutesPlanned.checked;

    return JSON.stringify(result);
  },

};
